import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../utils/apiRequest";
import { toast } from "react-toastify";
import { useRef } from "react";
import { useScroll } from "../devsathan_components/ScrollContext";

import ParticularEventHeader from "../components/particularEvent/Header";
import BenefitsSection from "../components/particularEvent/BenefitsSection";
import SubscriptionForm from "../components/Common/SubscriptionForm";
import Testimonials from "../components/Common/Testimonials";
import Countdown from "../components/Common/Countdown";
import Details from "../components/particularEvent/Details";
import AboutChadawa from "../components/particularEvent/AboutEvent";
import Cart from "../components/particularEvent/Cart";
import FAQSection from "../components/Common/FAQ";
import WaysToParticipate from "../components/particularEvent/WaysToParticipate";

import { BOOK_PUJA_PARTICIPATE_NOW_PARTICULAR_PAGE } from "../utils/gtmEventConstants";

import {
  PARTICULARCHADAWA,
  PARTICULARPUJA,
  TESTIMONIAL,
} from "../rest/endpoints";
import { pushGTMEvent } from "../utils/GTMEventComponent";
import { BOOK_CHADAWA_PARTICIPATE_NOW_PARTICULAR_PAGE } from "../utils/gtmEventConstants";
import ConditionalRenderer from "../devsathan_components/ConditionalRenderer";
import { useAuthHeaders } from "../utils/getHeaders";
import LoadingIndicator from "../components/Common/Loading";

const ParticularEvent = () => {
  const { eventtype, id } = useParams();
  const chadawa = "chadawa";
  const puja = "puja";
  const [scrolled, setScrolled] = useState(false);
  const headers = useAuthHeaders();
  const navigate = useNavigate();
  const translations = useSelector((state) => state.language.translations);
  const [testimonials, setTestimonials] = useState([]);
  const [particularEvent, setParticularEvent] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [activeTab, setActiveTab] = useState("participate"); // State to manage active tab
  const buttonRef = useRef(null);

  const { waysToParticipateRef } = useScroll();
  const cartRef = useRef(null);

  const { scrollToWaysToParticipate, isVisible } = useScroll();
  const [isFixed, setIsFixed] = useState(true);
  const stickyRef = useRef(null);

  useEffect(() => {
    if (activeTab === 'participate') {
      scrollToWaysToParticipate();
    }
  }, [activeTab]);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      },
      {
        root: null, // Observe within the viewport
        rootMargin: "0px",
        threshold: 0.1, // Trigger when at least 10% of the cart is visible
      }
    );

    if (cartRef.current) {
      observer.observe(cartRef.current);
    }

    return () => {
      if (cartRef.current) {
        observer.unobserve(cartRef.current);
      }
    };
  }, [cartRef.current]); // Ensure it re-observes when ref changes

  useEffect(() => {
    const fetchData = async () => {
      const url = eventtype === chadawa ? PARTICULARCHADAWA : PARTICULARPUJA;

      try {
        const result = await apiRequest({
          url: `${url}${id}`,
          method: "GET",
          headers,
        });

        if (result?.data) {
          setParticularEvent(result.data);
        } else {
          console.error("Chadawa data is missing or empty.");
          toast.error("Chadawa data is unavailable.");
        }
      } catch (error) {
        // Handle error gracefully and notify the user
        console.error(
          "Error fetching Chadawa data:",
          error.message || "Network or unknown error"
        );
        toast.error("Failed to fetch Chadawa data. Please try again later.");
      } finally {
        // Ensure loading state is updated regardless of the outcome
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      const result = await apiRequest({
        url: TESTIMONIAL,
        method: "GET",
        headers,
      });

      if (result?.data?.reviews && Array.isArray(result.data.reviews)) {
        setTestimonials(result.data.reviews); // Set state with the fetched testimonial data
      } else {
        console.error(
          "Testimonial data is missing or not in the expected format."
        );
        toast.error("Testimonial data is unavailable.");
      }
    };

    fetchTestimonials();
  }, []);

  useEffect(() => {
    const fetchTestimonials = async () => {
      const result = await apiRequest({
        url: TESTIMONIAL,
        method: "GET",
        headers,
      });

      if (Array.isArray(result?.data?.reviews)) {
        setTestimonials(result.data.reviews); // Set state with the fetched testimonial data
      } else {
        console.error(
          "Testimonial data is missing or not in the expected format."
        );
        toast.error("Testimonial data is unavailable.");
      }
    };

    fetchTestimonials();
  }, []);

  if (eventtype !== chadawa && eventtype !== puja) {
    return (
      <div className="flex items-center justify-center h-screen bg-light-pink">
        <div className="bg-custom-beige p-8 rounded-2xl shadow-md text-center max-w-md">
          <h1 className="text-3xl font-bold text-red-600 mb-4">404</h1>
          <p className="text-lg font-semibold mb-2 text-gray-800">
            Page Does Not Exist
          </p>
          <p className="text-gray-600 mb-6">
            The page you're looking for might have been removed or doesn't
            exist.
          </p>
          <button
            onClick={() => navigate("/")}
            className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg transition"
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#ffece5]">
      {isLoading ? (
        <LoadingIndicator />
      ) : !particularEvent ? (
        <div>No data available</div>
      ) : (
        <>
          <ParticularEventHeader
            particularEvent={particularEvent.mainSection}
          />

          <Details particularEvent={particularEvent} />
          <Countdown props={particularEvent} type={eventtype} />

          {eventtype === chadawa ? (
            <div>
              <div
                ref={stickyRef}
                className={`${
                  isFixed ? "fixed bottom-0 left-0 right-0" : "sticky top-14"
                } z-30 bg-[#FEEFDC] block sm:hidden px-10 pb-4 pt-3 w-full transition-all duration-300 ease-in-out`}
              >
                <div className="flex flex-row w-full md:w-auto md:mt-0 items-center justify-center sm:pl-6">
                  <button className="hidden border-2 border-orange-500 text-orange-500 rounded-full font-semibold hover:bg-orange-50 px-4 py-2">
                    Share
                  </button>
                  <button
                    ref={buttonRef}
                    onClick={() => {
                      if (!scrolled) {
                        setActiveTab('participate');
                        scrollToWaysToParticipate();
                        pushGTMEvent(
                          BOOK_CHADAWA_PARTICIPATE_NOW_PARTICULAR_PAGE,
                          {
                            event_value: particularEvent?.mainSection?.name,
                          }
                        );
                        setScrolled(true);
                      } else {
                        navigate("/cart");
                      }
                    }}
                    className="bg-orange-500 text-white px-6 py-2 rounded-[12px] font-semibold hover:bg-orange-600 text-[3.5vw]"
                  >
                    {scrolled
                      ? translations.bookChadawa
                      : translations.offerChadawa}
                  </button>
                </div>
              </div>
              <div
                ref={waysToParticipateRef}
                className="bg-[#FEEFDC] hidden sm:block"
              >
                <div ref={cartRef}>
                  <Cart
                    chadawaId={particularEvent?.id}
                    items={particularEvent?.offeringItemList}
                    eventType={particularEvent?.eventType}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div
                ref={stickyRef}
                className={`${
                  isFixed ? "fixed bottom-0 left-0 right-0" : "sticky top-14"
                } z-30 bg-[#FEEFDC] block sm:hidden px-10 pb-4 pt-3 w-full transition-all duration-300 ease-in-out`}
              >
                <div className="flex flex-row w-full md:w-auto md:mt-0 items-center justify-center sm:pl-6">
                  <button className="hidden border-2 border-orange-500 text-orange-500 rounded-full font-semibold hover:bg-orange-50 px-4 py-2">
                    {translations.shareButton}
                  </button>
                  {isVisible && (
                    <button
                      onClick={() => {
                        setActiveTab('participate');
                        scrollToWaysToParticipate();
                        pushGTMEvent(
                          BOOK_PUJA_PARTICIPATE_NOW_PARTICULAR_PAGE,
                          {
                            event_value: particularEvent?.mainSection?.name,
                          }
                        );
                      }}
                      ref={buttonRef}
                      // style={{ display: isVisible ? "block" : "none" }}
                      // className={`transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                      className="bg-orange-500 w-full text-white px-6 py-2 rounded-[12px] font-semibold hover:bg-orange-600 text-[3.5vw] transition-all duration-300 ease-in-out "
                    >
                      {translations.participateNow}
                    </button>
                  )}
                </div>
              </div>

              <div
                ref={waysToParticipateRef}
                className="bg-[#FEEFDC] px-8 md:px-14 hidden sm:block"
              >
                <WaysToParticipate
                  pooja={particularEvent}
                  id={particularEvent?.id}
                />
              </div>
            </div>
          )}
          <div className="hidden sm:block">
            <AboutChadawa
              particularEvent={particularEvent}
              eventType={eventtype}
            />

            <BenefitsSection
              particularEvent={particularEvent?.benefitsSection}
              eventType={eventtype}
            />

            <div className="pb-10">
              <FAQSection faqs={particularEvent?.faqSection} />
            </div>
          </div>
          <div className="w-full block sm:hidden mt-4 ">
            {/* Header with title */}
            {/* <h1 className="text-4xl font-bold text-amber-900 mb-4 mt-6 text-center">{translations.guide}</h1> */}

            {/* Tab Navigation */}
            <div className="flex justify-center mb-6 px-4">
              <div className="bg-amber-50 rounded-full p-1 flex border border-amber-200 w-full overflow-x-auto">
                <button
                  onClick={() => setActiveTab("participate")}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors flex-1 ${
                    activeTab === "participate"
                      ? "bg-orange-500 text-white"
                      : "text-amber-900 hover:bg-amber-100"
                  }`}
                >
                  {eventtype === "chadawa"
                    ? translations.offer
                    : translations.participate}
                </button>

                <button
                  onClick={() => setActiveTab("about")}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors flex-1 ${
                    activeTab === "about"
                      ? "bg-orange-500 text-white"
                      : "text-amber-900 hover:bg-amber-100"
                  }`}
                >
                  {translations.about}
                </button>
                <button
                  onClick={() => setActiveTab("benefits")}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors flex-1 ${
                    activeTab === "benefits"
                      ? "bg-orange-500 text-white"
                      : "text-amber-900 hover:bg-amber-100"
                  }`}
                >
                  {translations.benefits}
                </button>
                <button
                  onClick={() => setActiveTab("faq")}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors flex-1 ${
                    activeTab === "faq"
                      ? "bg-orange-500 text-white"
                      : "text-amber-900 hover:bg-amber-100"
                  }`}
                >
                  {translations.faq}
                </button>
              </div>
            </div>

            {/* Content based on selected tab */}
            <div className="mt-6">
              {activeTab === "participate" && (
                <>
                  {eventtype === "chadawa" ? (
                    <div
                      ref={waysToParticipateRef}
                      className="bg-[#FEEFDC] -mt-4"
                    >
                      <div ref={cartRef}>
                        <Cart
                          chadawaId={particularEvent?.id}
                          items={particularEvent?.offeringItemList}
                          eventType={particularEvent?.eventType}
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      ref={waysToParticipateRef}
                      className="bg-[#FEEFDC] px-8 md:px-14"
                    >
                      <WaysToParticipate
                        pooja={particularEvent}
                        id={particularEvent?.id}
                      />
                    </div>
                  )}
                </>
              )}

              {activeTab === "about" && (
                <AboutChadawa
                  particularEvent={particularEvent}
                  eventType={eventtype}
                />
              )}

              {activeTab === "benefits" && (
                <BenefitsSection
                  particularEvent={particularEvent?.benefitsSection}
                  eventType={eventtype}
                />
              )}

              {activeTab === "faq" && (
                <div className="pb-10">
                  <FAQSection faqs={particularEvent?.faqSection} />
                </div>
              )}
            </div>
          </div>

          <Testimonials testimonials={testimonials} />
          <ConditionalRenderer componentKey="SubscribeLandingpage">
            <SubscriptionForm />
          </ConditionalRenderer>
        </>
      )}
    </div>
  );
};

export default ParticularEvent;
